import React, { useState, useEffect } from "react";
import { Box, VStack, Heading, Text, useColorModeValue, Button, SimpleGrid, HStack,  Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,useBreakpointValue } from "@chakra-ui/react";
import axios from "axios";
import { StudentInfo } from "../Common/types";

const PaymentInfo = () => {

  const [currentStudent, SetCurrentStudent] = useState<StudentInfo>();
  const textColor = useColorModeValue("blue.800", "blue.50");
  const bannerColor = useColorModeValue("yellow.100", "yellow.700");
  const tableColor = useColorModeValue("gray.50", "gray.600");
  const showBanner = useBreakpointValue({ base: false, md: true }); // Hide footer on smaller screens

  const bankDetails = {
    accountName: process.env.REACT_APP_BANK_ACCOUNT_NAME || "N/A",
    bsb: process.env.REACT_APP_BANK_BSB || "N/A",
    accountNumber: process.env.REACT_APP_BANK_ACCOUNT_NUMBER || "N/A",
  };

  

  useEffect(() => {
    const fetchCurrentStudent = async () => {
      try {
        const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
        const response = await axios.get(`${apiurl}/students-info`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        SetCurrentStudent(response.data);
      } catch (error) {
        console.error("Error fetching Student Info:", error);
      }
    };
    fetchCurrentStudent();
  }, []);


  return (

    <Box>
         {showBanner && (
    <Box bgColor={bannerColor} p={4} height={"70px"}>
      <HStack>
        <Heading   size={"sm"}>Hello  {currentStudent?.givenName} ! </Heading>
        <Text  fontWeight={"normal"} fontSize={"md"}>Bank Account Details for making payments for fees.</Text>      
        </HStack>
    </Box>
      )}
      {!showBanner && (
      <Box p={4} bgColor={bannerColor} height={"50px"}>
        <VStack>
          <Text  fontWeight={"semibold"} fontSize={"md"}>Payment Info</Text>      
          </VStack>
      </Box>
      )}
    <Box as="main" mx="auto" maxWidth="1200px" color={textColor} p={10}>

    <Box
      p={6}
      bgColor={tableColor}
      borderWidth="1px"
      borderRadius="md"
      boxShadow="lg"
      maxW="400px"
      mx="auto"
    >
      <Heading size="md" textAlign="center" mb={4}>
        Bank Account Details
      </Heading>
      <Text mb={4} textAlign="center">
        Please use the following details for transactions:
      </Text>
      <TableContainer>
        <Table variant="striped" colorScheme="gray">
          <Thead>
            <Tr>
              <Th>Field</Th>
              <Th>Details</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>Account Name</Td>
              <Td>{bankDetails.accountName}</Td>
            </Tr>
            <Tr>
              <Td>BSB</Td>
              <Td>{bankDetails.bsb}</Td>
            </Tr>
            <Tr>
              <Td>Account Number</Td>
              <Td>{bankDetails.accountNumber}</Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </Box>

    </Box>
    </Box>
  );
};

export default PaymentInfo;
